import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface INameVideoInput {
	changeName: (value: string) => void;
}

const NameVideoInput: React.FC<INameVideoInput> = ({ changeName }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterVideoName') }], [t]);

	return (
		<FormInput
			testId="NameVideoInput"
			name="name"
			label="nameLabel"
			maxLength={50}
			onChange={changeName}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(NameVideoInput);
